"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergeStylesShadowRootContext = exports.useHasMergeStylesShadowRootContext = void 0;
var React = require("react");
var MergeStylesShadowRootContext_1 = require("../contexts/MergeStylesShadowRootContext");
/**
 * Test if a context is available.
 * @returns true if there is a context.
 */
var useHasMergeStylesShadowRootContext = function () {
    return !!(0, exports.useMergeStylesShadowRootContext)();
};
exports.useHasMergeStylesShadowRootContext = useHasMergeStylesShadowRootContext;
/**
 * Get a reference to the shadow root context.
 * @returns The context for the shadow root.
 */
var useMergeStylesShadowRootContext = function () {
    return React.useContext(MergeStylesShadowRootContext_1.MergeStylesShadowRootContext);
};
exports.useMergeStylesShadowRootContext = useMergeStylesShadowRootContext;
//# sourceMappingURL=useMergeStylesShadowRoot.js.map